import { useQuery } from "react-query";

import rillApi, { RillIframeRequest } from "manager/lib/rillApi";
import { NOTIFICATIONS } from "shared/config/constants";
import { openNotification } from "shared/utils/ui";

const GET_RILL_IFRAME = "getRillIframe";

const RILL_QUERY_KEYS = Object.freeze({
  getRillIframe: (params: RillIframeRequest) => [GET_RILL_IFRAME, params],
});

export const useGetRillDashboard = (
  params: RillIframeRequest,
  config: { enabled?: boolean } = {}
) => {
  const { enabled: callerEnabled = true, ...queryConfig } = config;
  const { data, isLoading, error, refetch } = useQuery(
    RILL_QUERY_KEYS.getRillIframe(params),
    () => rillApi.getRillIframe(params),
    {
      enabled: callerEnabled && Boolean(params.resource || params.navigation),
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error || "Failed to load analytics dashboard";
        openNotification(errorMessage, NOTIFICATIONS.error);
      },
      cacheTime: 5 * 60 * 1000,
      staleTime: 4 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      ...queryConfig,
    }
  );

  return {
    rillDashboard: data,
    isRillDashboardLoading: isLoading,
    rillDashboardError: error,
    refetchRillDashboard: refetch,
  };
}; 